export enum RotoMachinePartOutcome {
    GOOD = 'GOOD',
    BAD = 'BAD',
    DIDNT_RUN = 'DIDNT_RUN',
    OTHER = 'OTHER'
}
